import * as React from 'react';

const loading = () => {
  return (
    <div>
      Loading...
      <span className="icon is-large">
        <i className="fas fa-spinner fa-spin" />
      </span>
    </div>
  );
};

export default loading;



// WEBPACK FOOTER //
// ./src/components/Loading.tsx